import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import Pictures from "../../containers/Sell/PicturesContainer";
import SearchContainer from "../../containers/Sell/SearchContainer";
import NewContainer from "../../containers/Sell/NewContainer/NewContainer";
import CarSearchInformation from "../../containers/Sell/CarSearchInformationContainer";
import CarDetail from "../../containers/Sell/CarDetailContainer";
import Records from "../../containers/Sell/RecordsContainer";
import Confort from "../../containers/Sell/ConfortContainer";
import Tags from "../../containers/Sell/TagsContainer";
import ValueAndPayment from "../../containers/Sell/ValueAndPaymentContainer";
import Location from "../../containers/Sell/LocationContainer";
import Brand from "../../containers/Sell/BrandContainer";
import Year from "../../containers/Sell/YearContainer";
import Model from "../../containers/Sell/ModelContainer";
import ScheduleInspection from "../../containers/Sell/ScheduleInspectionContainer";
import Detail from "../../containers/Sell/DetailContainer";
import BrandNewCarContainer from "../../containers/Sell/BrandNewCarContainer";

const EntryPoint = React.lazy(() => import("../../containers/Sell/EntryPointContainer"));

const sellSubRoutes: RouteObject[] = [
    {
        title: "Sell",
        path: "new",
        component: <NewContainer/>
    },
    {
        title: "Sell",
        path: "search",
        component: <SearchContainer/>
    },
    {
        title: "Sell",
        path: "used-car",
        component: <SearchContainer/>
    },
    {
        title: "Sell",
        path: "new-car",
        component: <SearchContainer/>
    },
    {
        title: "Sell",
        path: "new-car-brand",
        component: <BrandNewCarContainer/>
    },
    {
        title: "Location",
        path: "steps",
        component: <Location/>
    },
    {
        title: "Brand",
        path: "brand",
        component: <Brand/>
    },
    {
        title: "Year",
        path: "year",
        component: <Year/>
    },
    {
        title: "Model",
        path: "model",
        component: <Model/>
    },
    {
        title: "car Detail",
        path: "car_detail",
        component: <CarDetail/>
    },
    {
        title: "records",
        path: "records",
        component: <Records/>
    },
    {
        title: "Confort",
        path: "confort",
        component: <Confort/>
    },
    {
        title: "Tags",
        path: "tags",
        component: <Tags/>
    },
    {
        title: "Pictures",
        path: "pictures",
        component: <Pictures/>
    },
    {
        title: "ValueAndPayment",
        path: "value_and_payment",
        component: <ValueAndPayment/>
    },
    {
        title: "CarSearchInformation",
        path: "car_search_information",
        component: <CarSearchInformation/>
    },
    {
        title: "Schedule inspection",
        path: ":id/schedule_inspection",
        component: <ScheduleInspection/>
    },
    {
        title: "Detail",
        path: "detail",
        component: <Detail/>
    }
]

export const sellRoutes: RouteObject[] = [
    {
        title: "Sell",
        path: "/sell",
        component: <EntryPoint/>,
        subRoutes: sellSubRoutes,
        protected: true
    }
];